import type {CellCoordinates, GridState, SerializedCellCoordinates} from '../types';
import {exists, isNull} from 'shared/utils/custom-utils';

export function isCellInEditMode(state: GridState, cell: CellCoordinates): boolean {
    return isInEditMode(state) && state.edit.editedCell.isEqualTo(cell);
}

export function isInEditMode(state: GridState): boolean {
    return exists(state.edit.editedCell);
}

export function isInNormalMode(state: GridState): boolean {
    return isNull(state.edit.editedCell);
}

export function isHover(state: GridState, cellCoordinates: CellCoordinates): boolean {
    if (exists(state.hover.hoverCursor) && state.hover.hoverCursor.isEqualTo(cellCoordinates)) {
        return true;
    }

    return includedIn(cellCoordinates, state.hover.hoverRow) || includedIn(cellCoordinates, state.hover.hoverColumn);
}

export function isCursor(state: GridState, cellCoordinates: CellCoordinates): boolean {
    return exists(state.cursor.physicalCursor) && state.cursor.physicalCursor.isEqualTo(cellCoordinates);
}

export function isHoverOrCursorRow(state: GridState, cellCoordinates: CellCoordinates): boolean {
    const isCursorRow = exists(state.cursor.physicalCursor) && state.cursor.physicalCursor.rowIndex === cellCoordinates.rowIndex;
    return isHover(state, cellCoordinates) || isCursorRow;
}

export function isSelected(state: GridState, cellCoordinates: CellCoordinates) {
    return includedIn(cellCoordinates, state.selected.allSelected);
}

export function isTopBorder(state: GridState, cellCoordinates: CellCoordinates) {
    return includedIn(cellCoordinates, state.selected.selectedTop);
}

export function isRightBorder(state: GridState, cellCoordinates: CellCoordinates) {
    return includedIn(cellCoordinates, state.selected.selectedRight);
}

export function isBottomBorder(state: GridState, cellCoordinates: CellCoordinates) {
    return includedIn(cellCoordinates, state.selected.selectedBottom);
}

export function isLeftBorder(state: GridState, cellCoordinates: CellCoordinates) {
    return includedIn(cellCoordinates, state.selected.selectedLeft);
}

export function includedIn(cellCoordinates: CellCoordinates, set: Set<SerializedCellCoordinates>): boolean {
    return set.has(cellCoordinates.serialize());
}

export function isVirtualCursor(state: GridState, cellCoordinates: CellCoordinates) {
    return exists(state.cursor.virtualCursor) && state.cursor.virtualCursor.isEqualTo(cellCoordinates);
}

export function isHighlightedDependency(state: GridState, cellCoordinates: CellCoordinates) {
    return includedIn(cellCoordinates, state.depended.depended);
}